import countries from "country-region-data";


export const getCountryName = function(countryCode) {
  var country = countries.filter(c => {
    return c.countryShortCode === countryCode;
  });
  if (country.length) {
    return country[0].countryName;
  }
  return '';
};
